import { ConcreteEncodable } from "./ConcreteEncodable";

import { FixingPositionStatusImplEncoder } from "../../encoder/FixingPositionStatusImplEncoder";

import * as CubiqTS from "../../index";
import { FixingPositionStatus } from "../FixingPositionStatus";

export class FixingPositionStatusImpl extends ConcreteEncodable implements FixingPositionStatus {
  public static enType: string = "com.bcdfx.model.FixingPositionStatusImpl";

  /*FID=1*/
  public baseCcyCd: string;
  /*FID=2*/
  public nonBaseCcyCd: string;
  /*FID=3*/
  public bmTimeCode: CubiqTS.BMTimeCode | null = null;
  /*FID=4*/
  public positionLevelState: CubiqTS.PositionLevelState;
  /*FID=5*/
  public positionOrderType: CubiqTS.PositionOrderType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FixingPositionStatusImplEncoder.Instance;
    this.setEncodableType(FixingPositionStatusImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FixingPositionStatusImpl[" +
      "baseCcyCd=" +
      this.baseCcyCd +
      "nonBaseCcyCd=" +
      this.nonBaseCcyCd +
      "bmTimeCode=" +
      this.bmTimeCode +
      "positionLevelState=" +
      this.positionLevelState +
      "positionOrderType=" +
      this.positionOrderType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
